<template>
    <div class="row" id="booking-setting">
        <div class="col-12">
            <form @submit.prevent="SaveBooking()">
                <div class="form-group d-flex align-items-center" style="margin-top: 10px;">
                    <label style="margin-right: 10px; width: 150px;">{{ lang.bssb_booking_calendar }}</label>
                    <label :for="bookingCalId" :class="['checkSwitch', 'badge badge-xs', booking_cal_enabled ? 'badge-success' : 'badge-secondary']">
                        <div class="iCheckswitch">
                            <input type="checkbox" :id="bookingCalId" v-model="booking_cal_enabled" />
                            <label class="iCheckswitch-label" :for="bookingCalId">
                                <span class="iCheckswitch-inner"></span>
                            </label>
                        </div>
                        <span class="form-check-label-text" v-if="booking_cal_enabled">{{ lang.bs_on }}</span>
                        <span class="form-check-label-text" v-else>{{ lang.bs_off }}</span>
                    </label>
                    <small style="margin-left: 10px; "> {{ lang.bssb_show_dates }}</small>
                </div>
                <div class="form-group d-flex align-items-center" style="margin-top: 10px;">
                    <label style="margin-right: 10px; width: 150px;" >{{ lang.bssb_schedule }}</label>
                    <label :for="scheduleCalId" :class="['checkSwitch', 'badge badge-xs', schedule_enabled ? 'badge-success' : 'badge-secondary', !booking_cal_enabled ? 'disabled' : '']">
                        <div class="iCheckswitch">
                            <input type="checkbox" :id="scheduleCalId" v-model="schedule_enabled" :disabled="!booking_cal_enabled"/>
                            <label class="iCheckswitch-label" :for="scheduleCalId">
                                <span class="iCheckswitch-inner"></span>
                            </label>
                        </div>
                        <span class="form-check-label-text" v-if="schedule_enabled">{{ lang.bs_on }}</span>
                        <span class="form-check-label-text" v-else>{{ lang.bs_off }}</span>
                    </label>
                    <small style="margin-left: 10px; "> {{ lang.bssb_show_times }} </small>
                </div>
                <div class="form-row" style="margin-bottom: 20px;">
                    <label >{{ lang.bssb_instructions }}</label>
                    <!-- detalles o indicaciones para a las personas q horas pueden escoger o q la fecha hora se confirmara despues de hacer la orden -->
                    <textarea v-model="booking_note" class="form-control"
                        :disabled="!booking_cal_enabled"
                        :placeholder="lang.bssb_instructions_ph"
                        style="min-height: 100px;"
                    ></textarea>
                </div>
                <div class="form-actions">
                    <button class="btn btn-primary btn-lg" type="submit">{{ lang.bs_save }}</button>
                    <button type="button" class="btn  btn-lg" @click="onCancel()">{{ lang.bs_cancel }}</button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: 'bStore_setup_booking',
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data(){
        return {
            lang: {
                bssb_booking_calendar: '',
                bs_on: '',
                bs_off: '',
                bssb_show_dates: '',
                bssb_schedule: '',
                bssb_show_times: '',
                bssb_instructions: '',
                bssb_instructions_ph: '',
                bs_save: '',
                bs_cancel: '',
            },
            booking_cal_enabled: this.value.booking_cal_enabled != null ? !!this.value.booking_cal_enabled : false,
            bookingCalId: `booking_cal_${Math.random().toString(36).slice(2, 6)}`,
            schedule_enabled: this.value.schedule_enabled != null ? !!this.value.schedule_enabled : false,
            scheduleCalId: `booking_cal_${Math.random().toString(36).slice(2, 6)}`,
            schedule: this.value.schedule || null,
            booking_note: this.value.booking_note || '',
        };
    },
    created(){
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            langGetter: "lang",
        }),
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    },
    methods: {
        SaveBooking(){
            // Implement save logic here
            const payload = {
                booking_cal_enabled: this.castBoolean(this.booking_cal_enabled) ? 1 : 0,
                schedule_enabled: this.castBoolean(this.schedule_enabled) ? 1 : 0,
                schedule: this.schedule,
                booking_note: this.booking_note,
            };
            this.$emit('save', payload);
        },
        onCancel() {
            this.$emit('cancel');
        },
        castBoolean(val) {
            if (typeof val === 'string') {
                return val === 'true' || val === '1';
            }
            if (typeof val === 'number') {
                return val !== 0;
            }
            return !!val;
        }
    }
}
</script>
<style scoped lang="scss">
#booking-setting {
    .form-actions {
        margin-top: 12px;
        display: flex;
        gap: 8px;
    }
}
</style>
